
const initialState = {
	reportTypes: false,
}

export const reportReducer = (state = initialState, action = {}) => {
   switch (action.type) {
         //case 'persist/REHYDRATE':
          //  return action.payload ? action.payload.reportReducer ? action.payload.reportReducer : state : state;
        case 'REPORTS_TYPES_FETCHED':
        	return {
                ...state,
                reportTypes: action.payload              
            }
        case 'DESTROY':
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reportReducer.js